import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../components/Table/Table';
import TableTabs from '../../components/TableTabs/TableTabs';
import Empty from '../../components/Empty/Empty';
import Loader from '../../components/Loader/Loader';
import getVinBlacklistCars from '../../api/vinBlacklist/getVinBlacklistCars';
import useServerTable from './useServerTable';

const tableStyle = { backgroundColor: 'white' };

// Машины, которые уже были в базе, когда их VIN попал в чёрный список. Ничего не удаляется и не снимается
// с наличия: на них могут быть сделки. Новые сделки по ним заблокированы, поэтому менеджеру полезно знать
// заранее, какие машины в стоке «мёртвые».
const VinBlacklistCars = () => {
  const columns = useMemo(
    () => [
      { Header: 'VIN', accessor: 'vin', width: '22%' },
      {
        Header: 'Машина',
        accessor: 'carId',
        Cell: ({ row }) => (
          <Link to={`/cars/car/${row.original.carId}/main-data`}>
            {[row.original.mark, row.original.model].filter(Boolean).join(' ') || `ID ${row.original.carId}`}
          </Link>
        ),
        width: '22%',
      },
      {
        Header: 'Цена, KZT',
        accessor: (row) => (row.price ? Number(row.price).toLocaleString('ru-RU') : '—'),
        width: '14%',
      },
      { Header: 'В наличии', accessor: (row) => row.stock ?? 0, width: '12%' },
      { Header: 'Сделки', accessor: (row) => row.deals ?? 0, width: '10%' },
      { Header: 'Причина', accessor: (row) => row.reason || '—' },
    ],
    []
  );

  const { table, tableProps, loaded, loading, searching, value, setValue, search } = useServerTable({
    fetcher: getVinBlacklistCars,
    key: 'cars',
    columns,
  });

  return (
    <>
      <TableTabs
        setFilter={search}
        value={value}
        setValue={setValue}
        inputPlaceholder="Быстрый поиск по VIN"
        advancedSearch={false}
        addButton={false}
      />
      <br />
      {!loaded ? (
        <Loader />
      ) : !table.page.length && !loading ? (
        <Empty title={searching ? 'По этому запросу ничего не найдено.' : 'Машин из чёрного списка в базе нет.'} />
      ) : (
        <Table
          {...tableProps}
          all={'машин'}
          style={tableStyle}
          api={'/api/crm/vin-blacklist/cars'}
          response={'cars'}
          edit={false}
        />
      )}
    </>
  );
};

export default VinBlacklistCars;
